import React, { useState } from "react";
import Title from "./Title";
import Navigation from "./Navigation";
import Background from "./Background";
import Container from 'react-bootstrap/Container';
import "./Home.css"

function Home(){

    const [imgColor, setImgColor] = useState("default");

    function setImg(color){
        setImgColor(color);
    }

    return(
        <section id="home">
            <div className="back">
                <Background />
            </div>
            <Container fluid className="home-container">
            <div className="navigate">
                <Navigation setimg={setImg} />  
            </div>
            <Title imgcolor={imgColor} />
            </Container>
        </section>
    );
}

export default Home;